// Screen `booking-manage` (owner: scheduling, owner feedback F13): an invitee's own booking page, by the
// token in their confirmation mail: details, add to calendar, move, cancel.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PublicManagePage } from '../../../features/scheduling/PublicManagePage';

export const Route = createFileRoute('/_public/meeting/$token')({
  validateSearch: z.object({
    lang: z.enum(['en', 'de']).optional().catch(undefined),
    embed: z
      .union([z.boolean(), z.enum(['1', 'true', '0', 'false'])])
      .transform((v) => v === true || v === '1' || v === 'true')
      .optional()
      .catch(undefined),
  }),
  head: () => ({
    meta: [
      { name: 'robots', content: 'noindex, nofollow' },
      { name: 'referrer', content: 'no-referrer' },
    ],
  }),
  component: function MeetingRoute() {
    const { token } = Route.useParams();
    return <PublicManagePage token={token} search={Route.useSearch()} />;
  },
});
